import { MilestoneProvider, useMilestoneContext } from "@/contexts/MilestoneContext";
import { MilestoneCelebration, MilestoneType } from "./MilestoneCelebration";
import { useLocation } from "wouter";

function MilestoneCelebrationUI() {
  const { celebrationMilestone, dismissCelebration } = useMilestoneContext();
  const [, setLocation] = useLocation();

  const handleCtaClick = (milestone: MilestoneType) => {
    switch (milestone) {
      case 'first_sms_sent':
        // Navigate to AI composer or messaging page
        setLocation('/inbox');
        break;
      case 'first_call_made':
        // Navigate to AI voice agents page
        setLocation('/voice-agents');
        break;
      case 'contacts_10_added':
        // Navigate to campaigns page
        setLocation('/messaging');
        break;
      case 'ai_composer_used':
        // Just dismiss, no navigation needed
        break;
    }
  };

  return (
    <MilestoneCelebration
      milestone={celebrationMilestone}
      onClose={dismissCelebration}
      onCtaClick={handleCtaClick}
    />
  );
}

export function MilestoneCelebrationProvider({ children }: { children: React.ReactNode }) {
  return (
    <MilestoneProvider>
      {children}
      <MilestoneCelebrationUI />
    </MilestoneProvider>
  );
}
